import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./skills.css";

import AOS from 'aos';
import 'aos/dist/aos.css';

import html from "../../assets/icons/html.png";
import css from "../../assets/icons/css.png";
import js from "../../assets/icons/javascript.png";
import github from "../../assets/icons/github.png";
import react from '../../assets/icons/react.png'

export default function Skills() {

  useEffect(() => {
    AOS.init();
  }, [])

  const navigate = useNavigate();

  function goToContact() {
    navigate("/contact");
  }

  return (
      <div className="skills" id="skills">
        <div className="skills--info" data-aos="fade-right">
          <p className="tag">Habilidades</p>
          <p className="tittle">Quais são minhas habilidades atuais?</p>
          <p>
            Desenvolvo interfaces simples, intuitivas e responsivas que ajudam os usuários a fazer
            tudo com menos esforço e tempo com essas tecnologias.
          </p>
          <button className="primary-button skills--btn" onClick={goToContact}>Contato</button>
        </div>
        <div className="skills--icons">
          <img src={html} alt="" data-aos="flip-up" data-aos-duration='400' data-aos-delay='100'/>
          <img src={css} alt="" data-aos="flip-up" data-aos-duration='400' data-aos-delay='200'/>
          <img src={js} alt="" data-aos="flip-up" data-aos-duration='400' data-aos-delay='300'/>
          <img src={react} alt="" data-aos="flip-up" data-aos-duration='400' data-aos-delay='400'/>
          <img src={github} alt="" data-aos="flip-up" data-aos-duration='400' data-aos-delay='500'/>
        </div>
      </div>
  );
}
